import Career from "./Career";
import Resources from "./Resources";
import Community from "./Community";
import Store from "./Store";
import About from "./About";

import dynamic from "next/dynamic";

// const DynamicCareer = dynamic(() => import("./Career"), {
// 	loading: () => <header />,
// });
// const DynamicResources = dynamic(() => import("./Resources"), {
// 	loading: () => <header />,
// });
// const DynamicCommunity = dynamic(() => import("./Community"), {
// 	loading: () => <header />,
// });
// const DynamicStore = dynamic(() => import("./Store"), {
// 	loading: () => <header />,
// });
// const DynamicAbout = dynamic(() => import("./About"), {
// 	loading: () => <header />,
// });
function switchMegaNav(name) {
	switch (name) {
		case "Career":
			return <Career />;

		case "Resources":
			return <Resources />;

		case "Community":
			return <Community />;
		case "About":
			return <About />;
		case "Store":
			return <Store />;

		default:
			break;
	}
}

export default switchMegaNav;
